module.exports = __webpack_public_path__ + "static/img/tsLogoGray.eadac983.png";